import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Tabs } from "../components/ui";
import { spendViewOf, type SpendView } from "../lib/spendView";
import ExpensesSection from "./ExpensesSection";
import TimelineSection from "./TimelineSection";

// Flujo → Gastos (B): en qué se gastó y cuándo, en una sola página. La lista de
// gastos y «¿Cuándo se gastó?» eran dos secciones; ahora son dos vistas de la
// misma, y la vista elegida viaja en la URL (`?view=timeline`).
export default function SpendSection() {
  const { t } = useTranslation("common");
  const [params, setParams] = useSearchParams();
  const view = spendViewOf(params.get("view"));

  const change = (next: SpendView) => {
    const copy = new URLSearchParams(params);
    if (next === "list") copy.delete("view");
    else copy.set("view", next);
    setParams(copy, { replace: true });
  };

  return (
    <div className="flex min-h-0 w-full max-w-6xl flex-col" data-testid="spend-section">
      <div className="px-4 pt-4 sm:px-6">
        <Tabs
          label={t("expenses.menu.expenses")}
          value={view}
          onChange={change}
          tabs={[
            { id: "list", label: t("expenses.spend.list"), icon: "ri-receipt-line" },
            { id: "timeline", label: t("expensesStatements:menu.timeline"), icon: "ri-calendar-2-line" },
          ]}
        />
      </div>
      {view === "timeline" ? <TimelineSection /> : <ExpensesSection />}
    </div>
  );
}
